export * from './page-type-properties'
